'use client';

import React from 'react';
import { BackToTopButton } from 'src/components/animate/back-to-top-button';
import { ScrollProgress, useScrollProgress } from 'src/components/animate/scroll-progress';
import { BusinessSectorNeeds, DigitalControl } from '../business-sector-needs';
import { BusinessSectors } from '../business-sectors';
import { BusinessServiceForm } from '../service-form';
import { BusinessSolutions } from '../business-solutions';

// ----------------------------------------------------------------------

export function BusinessView() {
  const pageProgress = useScrollProgress();

  return (
    <>
      <ScrollProgress
        variant="linear"
        progress={pageProgress.scrollYProgress}
        sx={{ position: 'fixed' }}
      />

      <BackToTopButton />
      <BusinessServiceForm />
      <BusinessSolutions />
      <BusinessSectors />
      <BusinessSectorNeeds />
    </>
  );
}
